import { ReservationUrls } from '../features/reservation/constants/urls';

/**
 * QueryStringRouteManagerから呼び出されるリダイレクト先URL一覧。
 */
export const RedirectURLs = {
  index: { url: ReservationUrls.Reservation, allowedQuery: [], state: {} },
  reservation: { url: ReservationUrls.Reservation, allowedQuery: ['outpatientid'], state: { step: 2 } },
  reservationMemberstatus: {
    url: ReservationUrls.ReservationMemberstatus,
    allowedQuery: ['outpatientid'],
    state: { step: 2 }
  },
  registration: { url: ReservationUrls.Registration, allowedQuery: [], state: {} },
  mypage: { url: ReservationUrls.Mypage, allowedQuery: [], state: {} }
};

export type RedirectKey = keyof typeof RedirectURLs;
